import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { removeIdentityFix } from '@/lib/history'
import type { HistoryWorklistEntry } from '@/api/types'

interface HistoryOtherCardProps {
  entry: HistoryWorklistEntry
  isDisabled: boolean
  onChange: (entry: HistoryWorklistEntry) => void
}

export function HistoryOtherCard({ entry, isDisabled, onChange }: HistoryOtherCardProps): React.ReactElement | null {
  const hasIdentityFix = entry.identityFix !== null
  const hasOtherSale = entry.otherSaleDeliveries.length > 0

  if (!hasIdentityFix && !hasOtherSale) return null

  return (
    <Card className="shadow-none border-border/80">
      <CardHeader>
        <CardTitle>5. Övrigt</CardTitle>
        <CardDescription>Annat avstämningen tog upp för kunden.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        {hasIdentityFix && (
          <p className="flex items-center justify-between gap-3">
            <span>
              Personnumret rättas från {entry.identityFix?.from} till {entry.identityFix?.to} (bekräftat av teamet).
            </span>
            <Button
              variant="ghost"
              size="sm"
              className="rounded-none text-destructive hover:text-destructive"
              disabled={isDisabled}
              onClick={() => onChange(removeIdentityFix(entry))}
            >
              Rätta inte
            </Button>
          </p>
        )}
        {hasOtherSale && (
          <p className="text-muted-foreground">
            Paket från en äldre affär, räknas inte i det här abonnemanget:{' '}
            {entry.otherSaleDeliveries.map((delivery) => `leverans ${delivery.sequence} (${delivery.sentOn}, ${delivery.sale})`).join(', ')}
            .
          </p>
        )}
      </CardContent>
    </Card>
  )
}
